import { startTransition, useCallback, useEffect, useState } from "react";

import Button from "@/design-system/button";
import ChevronUp from "@/design-system/icons/chevron-up";
import * as stylex from "@stylexjs/stylex";

import { ComposableSpacing, colors, genericStyles } from "../../../styles/tokens.stylex";

export default function ScrollTop() {
    const [isStuck, setIsStuck] = useState(false);
    const [zoomLevel, setZoomLevel] = useState(1);

    const onScroll = useCallback(() => {
        const isScrolled = window.scrollY > 25;
        setIsStuck(isScrolled);
    }, []);

    const detectZoom = useCallback(() => {
        const zoom = window.outerWidth / window.innerWidth;
        setZoomLevel(zoom);
    }, []);

    useEffect(() => {
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, [onScroll]);

    useEffect(() => {
        detectZoom();
        window.addEventListener("resize", detectZoom, { passive: true });
        return () => window.removeEventListener("resize", detectZoom);
    }, [detectZoom]);

    const handleScrollTop = useCallback(() => {
        startTransition(() => {
            window.scrollTo({ top: 0, behavior: "smooth" });
        });
    }, []);

    const scale = zoomLevel >= 1.5 ? styles.scaleHalf : styles.scaleNormal;

    return (
        <Button
            as="button"
            styleX={[styles.scrollTopComponent, isStuck && styles.show, scale]}
            onClick={handleScrollTop}
            variant="magentaRound"
            size="M"
        >
            <span {...stylex.props(styles.arrow)}>
                <ChevronUp />
            </span>
        </Button>
    );
}

const styles = stylex.create({
    scrollTopComponent: {
        borderRadius: genericStyles.borderRadiusFullRound,
        display: "block",
        opacity: 0,
        pointerEvents: "none",
        position: "absolute",
        transitionDuration: ".15s",
        transitionProperty: "opacity, visibility, translate",
        translate: "-1rem 0",
        visibility: "hidden",
        zIndex: 1,
        paddingBottom: ComposableSpacing.s2,
        paddingLeft: ComposableSpacing.s2,
        paddingRight: ComposableSpacing.s2,
        paddingTop: ComposableSpacing.s2,
        right: "1rem",
        top: "-3rem",
    },
    scaleNormal: {
        transform: "scale(1)",
    },
    scaleHalf: {
        transform: "scale(0.5)",
    },
    show: {
        opacity: 1,
        pointerEvents: "all",
        translate: "-1rem -1rem",
        visibility: "visible",
    },
    arrow: {
        color: colors.b_Primary,
        display: "block",
        height: 24,
        width: 24,
    },
});
